// @flow

import React from 'react';
/* $FlowFixMe This comment suppresses an error found when upgrading Flow to
 * v0.104.0. To view the error, delete this comment and run Flow. */
import styled, { css, type ReactComponentStyled } from 'styled-components';
import { placeholder } from 'polished';
import { padding, fontWeight, colors } from '../../constants';

export type InputProps = {
  disabled: boolean,
  readOnly: boolean,
  block: boolean,
  inputRef: (HTMLInputElement) => void,
  type: string,
  autoFocus: boolean,
  selectOnFocus: boolean,
  onChange?: (SyntheticEvent<HTMLInputElement>) => void,
  value?: null | typeof undefined | string,
  width?: string,
};

export default class Input extends React.Component<InputProps> {
  static defaultProps = {
    disabled: false,
    readOnly: false,
    block: false,
    inputRef: () => {},
    type: 'text',
    focusBorderColor: colors.mediumGreenhouseGreen,
    autoFocus: false,
    selectOnFocus: false,
  };

  onFocus = (evt: SyntheticEvent<HTMLTextAreaElement>) => {
    if (this.props.selectOnFocus) {
      evt.currentTarget.select();
    }
  };

  render() {
    const { autoFocus, disabled, readOnly, block, inputRef, ...otherProps } =
      this.props;
    const ComponentType = block ? BlockInputElem : InputElem;

    return (
      /* $FlowFixMe This comment suppresses an error found when upgrading Flow
       * to v0.92.0. To view the error, delete this comment and run Flow. */
      <ComponentType
        ref={inputRef}
        autoFocus={autoFocus}
        onFocus={this.onFocus}
        disabled={disabled}
        readOnly={readOnly}
        {...otherProps}
      />
    );
  }
}

type InputElemProps = { width: string, readOnly: boolean };
const InputElem: ReactComponentStyled<InputElemProps, *> = styled.input`
  &&&& {
    line-height: 1.5;
    font-size: 14px;
    color: ${colors.darkestGrey};
    border: 1px solid ${colors.lightGrey};
    box-sizing: border-box;
    border-radius: 2px;
    width: ${(props) => props.width || 'inherit'};
    padding: ${padding.tiny} ${padding.small};

    ${placeholder({
      font: `${fontWeight.normal} 14px 'Untitled Sans Regular', sans-serif`,
      color: `${colors.mediumGrey}`,
      'line-height': '1.5',
    })};

    ${(props) =>
      props.readOnly &&
      css`
        background-color: ${colors.lightestGrey};
      `}

    &:focus {
      border-color: ${(props) => props.focusBorderColor};
      outline: none;
    }
  }
`;

const BlockInputElem: typeof InputElem = styled(InputElem)`
  &&&& {
    display: block;
    width: 100%;
  }
`;
